import React, { useState } from "react";
import { Card } from "react-bootstrap";
import Button from "../../atoms/Buttons/Button/Button";
import FloatingCallWidget from "./FloatingCallWidget";
import {
  cleanPhoneNumberInput,
  validatePhoneNumber,
  ValidationResult,
} from "../../../utils/validationUtils";

import { PhoneInput } from "react-international-phone";
import "react-international-phone/style.css";

interface CallWidgetProps {
  leadId: number;
  onRecordingComplete?: (recordingData: any) => void;
}

const CallWidget: React.FC<CallWidgetProps> = ({
  leadId,
  onRecordingComplete,
}) => {
  const [showInput, setShowInput] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [errors, setErrors] = useState({ error: false, message: "" });
  const [clickSubmit, setClickSubmit] = useState(false);
  const [showFloatingWidget, setShowFloatingWidget] = useState(false);
  const [hideCallButton, setHideCallButton] = useState(false);

  const handleInputChange = (
    value: string | React.ChangeEvent<HTMLInputElement>
  ) => {
    let cleanedValue: string;

    if (typeof value === "string") {
      cleanedValue = cleanPhoneNumberInput(value);
    } else {
      cleanedValue = cleanPhoneNumberInput(value.target.value);
    }

    setPhoneNumber(cleanedValue);

    if (clickSubmit) {
      const validation = validatePhoneNumber(cleanedValue);
      setErrors({ error: !validation.isValid, message: validation.message });
    }
  };
  const handleCallButtonClick = () => {
    if (!showInput) {
      setShowInput(true);
    } else {
      setClickSubmit(true);
      const validation = validatePhoneNumber(phoneNumber);
      setErrors({ error: !validation.isValid, message: validation.message });

      if (validation.isValid) {
        setShowFloatingWidget(true);
        setHideCallButton(true);
        setShowInput(false);
        setClickSubmit(false);
        setErrors({ error: false, message: "" });
      }
    }
  };

  const handleCloseFloatingWidget = (recordingData?: any) => {
    setShowFloatingWidget(false);
    setHideCallButton(false);
    setPhoneNumber("");
    setShowInput(false);
    setClickSubmit(false);
    setErrors({ error: false, message: "" });

    if (recordingData && onRecordingComplete) {
      onRecordingComplete(recordingData);
    }
  };

  return (
    <>
      {!hideCallButton && (
        <Card className="call-widget">
          <Card.Body className="call-widget-body">
            {showInput && (
              <div className="phone-input-container">
                <PhoneInput
                  defaultCountry="au"
                  value={phoneNumber}
                  onChange={(phoneNumber) => handleInputChange(phoneNumber)}
                />
              </div>
            )}
            <div className="call-button-container">
              <Button
                text={showInput ? "" : "Call Now"}
                icon="leads"
                onClick={handleCallButtonClick}
                activeColor="#007bff"
                cssClass={showInput ? "call-now-btn btn" : "btn-primary" }
              />
            </div>
          </Card.Body>
        </Card>
      )}

      {showFloatingWidget && (
        <FloatingCallWidget
          phoneNumber={phoneNumber}
          onClose={handleCloseFloatingWidget}
        />
      )}
    </>
  );
};

export default CallWidget;
